import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '@src/components/Forms/ContactPage'
import { CmsLeadForm } from '@src/components/LeadForm/CmsLeadForm'
import { useFormSettings } from '@src/components/LeadForm/useFormSettings'
import Request from '@src/services/api/Request'
import { routePageHead } from '@src/utils/routeHead'
import type { ContactPageAttributes } from '@src/types/contactPage'

export const Route = createFileRoute('/contact-us')({
  loader: async () => {
    const contactPage = await Request.contactUs()
    return { contactPage: contactPage?.attributes ?? null }
  },
  head: ({ loaderData }) =>
    routePageHead(loaderData?.contactPage?.seo?.pageTitle),
  component: ContactUsPage,
})

function ContactUsPage() {
  const formSettings = useFormSettings()
  const { contactPage } = Route.useLoaderData() as {
    contactPage: ContactPageAttributes | null
  }

  return (
    <ContactPage contactPage={contactPage}>
      <CmsLeadForm leadForm={formSettings?.contactUs} />
    </ContactPage>
  )
}
